import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { APP_URL } from "../lib/config";

type Props = {
  code: string;
  tenantId: string;
  tenantName: string;
  discountPercent: number;
};

export function AmbassadorShareKit({ code, tenantId, tenantName, discountPercent }: Props) {
  const [qrDataUrl, setQrDataUrl] = useState<string | null>(null);
  const url = `${APP_URL}/?join=${encodeURIComponent(tenantId)}&ref=${encodeURIComponent(code)}`;
  const waText = `Hola! Te dejo mi codigo de descuento para ${tenantName}: ${code}. Usa el link y obtienes ${discountPercent}% off automatico: ${url}`;
  const igCaption = `Mi codigo en ${tenantName}: ${code}. Link en bio o descarga la app y aplica ${discountPercent}% off.`;

  useEffect(() => {
    QRCode.toDataURL(url, { width: 600, margin: 2, errorCorrectionLevel: "M" }).then(setQrDataUrl);
  }, [url]);

  const copy = async (text: string, label: string) => {
    try {
      await navigator.clipboard.writeText(text);
      alert(`${label} copiado al portapapeles.`);
    } catch {
      /* ignore */
    }
  };

  const downloadQr = () => {
    if (!qrDataUrl) return;
    const a = document.createElement("a");
    a.href = qrDataUrl;
    a.download = `qr-${code}.png`;
    a.click();
  };

  return (
    <div className="card flex flex-col gap-3">
      <h3 className="text-sm font-medium text-leaf-800">Compartir {code}</h3>

      <div className="grid grid-cols-3 gap-2">
        <a
          href={`https://wa.me/?text=${encodeURIComponent(waText)}`}
          target="_blank"
          rel="noreferrer"
          className="rounded-xl bg-green-600 px-3 py-2 text-center text-xs font-medium text-white"
        >
          WhatsApp
        </a>
        <button
          onClick={() => copy(igCaption, "Caption Instagram")}
          className="rounded-xl bg-pink-600 px-3 py-2 text-xs font-medium text-white"
        >
          IG caption
        </button>
        <button
          onClick={downloadQr}
          disabled={!qrDataUrl}
          className="rounded-xl bg-leaf-700 px-3 py-2 text-xs font-medium text-white disabled:opacity-50"
        >
          QR PNG
        </button>
      </div>

      <button
        onClick={() => copy(url, "Link")}
        className="rounded-xl bg-leaf-50 px-3 py-2 text-xs text-leaf-800 ring-1 ring-leaf-200"
      >
        Copiar link directo
      </button>

      {qrDataUrl && (
        <details className="text-xs text-leaf-600">
          <summary className="cursor-pointer">Ver QR para imprimir</summary>
          <img src={qrDataUrl} alt="QR" className="mx-auto mt-2 w-40" />
        </details>
      )}
    </div>
  );
}
